import './headerActionBar.scss';

import { useIntl } from 'react-intl';
import { Icon } from '@eliberty/design-system-react';

interface HeaderActionBarProps {
  /**
   * The main title to be displayed in the header.
   */
  title: string;
  /**
   * The subTitle text displayed below the title (e.g. "View details").
   */
  subTitle: string;
  /**
   * Optional callback for the chevron back button. When omitted, the button is not rendered.
   */
  onBackClick?: () => void;
  /**
   * Callback for clicking the title/subtitle zone (e.g. opens a detail modal).
   */
  onDetailsClick: () => void;
}

/**
 * A functional header component with two independent interaction zones:
 * - A back chevron button (smartBack navigation)
 * - A titles area button (opens product details modal)
 */
const HeaderActionBar = ({
  title,
  subTitle,
  onBackClick,
  onDetailsClick,
}: HeaderActionBarProps) => {
  const intl = useIntl();

  return (
    <div className='HeaderActionBar'>
      {onBackClick && (
        <button
          type='button'
          className='HeaderActionBar_backButton'
          onClick={onBackClick}
          aria-label={intl.formatMessage({ defaultMessage: 'Back', id: 'back' })}
        >
          <Icon name='chevron-left' />
        </button>
      )}
      <button type='button' className='HeaderActionBar_titlesContainer' onClick={onDetailsClick}>
        <div className='HeaderActionBar_title'>{title}</div>
        <div className='HeaderActionBar_subtitle'>{subTitle}</div>
      </button>
    </div>
  );
};

export default HeaderActionBar;
